export type CertificateType = 'course' | 'programme' | 'diploma' | string

export interface Certificate {
  id: string | null
  userId: string | null
  type: CertificateType | null
  courseId: string | null
  programmeId: string | null
  title: string | null
  issuedAt: string | null
  certificateNumber: string | null
  downloadUrl: string | null
  isValid: boolean | null
  verifyToken: string | null
  verifyTokenExpiresAt: string | null
  isRevoked: boolean | null
  notes: string | null
  issuedByUserId: string | null
  issuedVia: string | null
  storageKey: string | null
  checksum: string | null
  createdAt: string | null
  updatedAt: string | null
}

export class CertificateModel implements Certificate {
  id: string | null
  userId: string | null
  type: CertificateType | null
  courseId: string | null
  programmeId: string | null
  title: string | null
  issuedAt: string | null
  certificateNumber: string | null
  downloadUrl: string | null
  isValid: boolean | null
  verifyToken: string | null
  verifyTokenExpiresAt: string | null
  isRevoked: boolean | null
  notes: string | null
  issuedByUserId: string | null
  issuedVia: string | null
  storageKey: string | null
  checksum: string | null
  createdAt: string | null
  updatedAt: string | null

  constructor(data?: Partial<CertificateModel>) {
    this.id = data?.id ?? null
    this.userId = data?.userId ?? null
    this.type = data?.type ?? null
    this.courseId = data?.courseId ?? null
    this.programmeId = data?.programmeId ?? null
    this.title = data?.title ?? null
    this.issuedAt = data?.issuedAt ?? null
    this.certificateNumber = data?.certificateNumber ?? null
    this.downloadUrl = data?.downloadUrl ?? null
    this.isValid = data?.isValid ?? null
    this.verifyToken = data?.verifyToken ?? null
    this.verifyTokenExpiresAt = data?.verifyTokenExpiresAt ?? null
    this.isRevoked = data?.isRevoked ?? null
    this.notes = data?.notes ?? null
    this.issuedByUserId = data?.issuedByUserId ?? null
    this.issuedVia = data?.issuedVia ?? null
    this.storageKey = data?.storageKey ?? null
    this.checksum = data?.checksum ?? null
    this.createdAt = data?.createdAt ?? null
    this.updatedAt = data?.updatedAt ?? null
  }

  static fromJSON(json: any): CertificateModel {
    if (!json) {
      return new CertificateModel()
    }

    return new CertificateModel({
      id: json.id ?? json.certificateId ?? null,
      userId: json.user_id ?? json.userId ?? null,
      type: json.type ?? null,
      courseId: json.course_id ?? json.courseId ?? null,
      programmeId: json.programme_id ?? json.programmeId ?? null,
      title: json.title ?? null,
      issuedAt: json.issued_at ?? json.issuedAt ?? null,
      certificateNumber: json.certificate_number ?? json.certificateNumber ?? null,
      downloadUrl: json.download_url ?? json.downloadUrl ?? null,
      isValid: json.is_valid ?? json.isValid ?? null,
      verifyToken: json.verify_token ?? json.verifyToken ?? null,
      verifyTokenExpiresAt: json.verify_token_expires_at ?? json.verifyTokenExpiresAt ?? null,
      isRevoked: json.is_revoked ?? json.isRevoked ?? null,
      notes: json.notes ?? null,
      issuedByUserId: json.issued_by_user_id ?? json.issuedByUserId ?? null,
      issuedVia: json.issued_via ?? json.issuedVia ?? null,
      storageKey: json.storage_key ?? json.storageKey ?? null,
      checksum: json.checksum ?? null,
      createdAt: json.created_at ?? json.createdAt ?? null,
      updatedAt: json.updated_at ?? json.updatedAt ?? null,
    })
  }
}
